import React from 'react';
import { Field, Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { enviaFormRequest } from '@store/user/actions';
import { Button, Toggler, TextInfo, TextInput } from '@components';

export const PortabilidadeB = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { matricula, dadosPessoais } = useSelector((state) => state.user);

  const initialValues = {
    nome: dadosPessoais.nome,
    cpf: dadosPessoais.cpf,
    matricula,

    logradouro: dadosPessoais.logradouro,
    numero: dadosPessoais.numero,
    complemento: dadosPessoais.complemento,
    bairro: dadosPessoais.bairro,
    cidade: dadosPessoais.cidade,
    estado: dadosPessoais.estado,
    cep: dadosPessoais.cep,

    telefone: dadosPessoais.telefone,
    celular: dadosPessoais.celular,
    email: dadosPessoais.email,
  };

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>
        <p className="mb-3">
          Considerando o disposto no Regulamento do Plano Misto de Benefícios
          Previdenciários da Forluz (Plano B), venho, por meio deste, formalizar
          minha opção pelo Benefício Proporcional Diferido.
        </p>
        <Formik
          validateOnMount
          initialValues={initialValues}
          // validationSchema={AutopatrocinioSchema}
          onSubmit={(values) => {
            dispatch(
              enviaFormRequest({
                campos: values,
                formulario: reference,
                navigate,
              })
            );
          }}
        >
          {({ handleSubmit, isValid }) => {
            return (
              <Form>
                <div className="row mb-3">
                  <p className="fw-bold mb-2">IDENTIFICAÇÃO DO PARTICIPANTE</p>
                  <div className="col-md-12 col-lg-6">
                    <Field name="nome" component={TextInput} label="Nome" />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <Field name="cpf" component={TextInput} label="Cpf" />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <Field
                      name="matricula"
                      component={TextInput}
                      label="Matricula"
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <p className="mb-2">Endereço residencial</p>
                  <div className="col-md-12 col-lg-6">
                    <Field
                      name="logradouro"
                      component={TextInput}
                      label="Logradouro"
                    />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <Field name="numero" component={TextInput} label="Número" />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <Field
                      name="complemento"
                      component={TextInput}
                      label="Complemento"
                    />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <Field name="bairro" component={TextInput} label="Bairro" />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <Field
                      name="cidade"
                      component={TextInput}
                      label="Município"
                    />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <Field name="estado" component={TextInput} label="UF" />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <Field name="cep" component={TextInput} label="CEP" />
                  </div>
                </div>

                <div className="row mb-3">
                  <p className="mb-2">Contato</p>
                  <div className="col-md-12 col-lg-6">
                    <Field
                      name="telefone"
                      component={TextInput}
                      label="Telefone fixo"
                    />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <Field
                      name="celular"
                      component={TextInput}
                      label="Celular"
                    />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <Field name="email" component={TextInput} label="E-mail" />
                  </div>
                </div>

                <div className="row mb-3">
                  <p className="fw-bold">
                    IDENTIFICAÇÃO DA ENTIDADE QUE ADMINISTRA O PLANO DE
                    BENEFÍCIOS ORIGINÁRIO
                  </p>
                  <TextInfo
                    text="Nome"
                    info="Fundação Forluminas de Seguridade Social - FORLUZ"
                  />
                  <TextInfo
                    text="Endereço"
                    info="Av. Contorno, 6500 / 3º andar - Funcionários"
                  />
                  <TextInfo text="Cidade" info="Belo Horizonte" />
                  <TextInfo text="UF" info="MG" />
                  <TextInfo text="CEP" info="30110-044" />
                  <TextInfo
                    text="Nome do Plano de Benefício"
                    info="Plano Misto"
                  />
                  <TextInfo text="CNPB" info="19.970.027-11" />
                  <TextInfo text="CNPJ" info="16.539.926-0001/90" />
                  <TextInfo
                    text="Nome da Pessoa para Contato"
                    info="Supervisor de Atuária e Segur."
                  />
                  <TextInfo text="Telefone" info="0800 0909090" />
                  <TextInfo text="E-mail" info="atendimento@forluz.org.br" />
                </div>

                <div className="row mb-3">
                  <p>
                    O Direito Acumulado Total será atualizado entre a data-base
                    de cálculo e a data da efetiva transferência para o Plano de
                    Benefícios Receptor.
                  </p>
                </div>

                <div className="row">
                  <Field
                    name="declaracao"
                    component={Toggler}
                    tooltip="Instituto que faculta ao participante a transferência dos recursos entre Entidades de Previdência, sejam fechadas, como a Forluz, ou aberta, como o PGBL dos bancos. A opção poderá ser feita a qualquer momento, desde que ainda possua saldo na conta de aposentadoria e não esteja usufruindo de benefício. O montante a ser portado é o valor bruto do resgate, informado no extrato da conta de aposentadoria."
                    label="Declaro por meio deste, nos termos do Regulamento do Plano Misto de Benefícios – Plano B, exercer a opção de portabilidade de sua Conta de Aposentadoria, conforme informações acima, com as quais declara estar plenamente de acordo. Por oportuno, declaro ter plena ciência de que a Portabilidade implica ne cessação de quaisquer direitos e deveres em face do Plano B e da Forluz, dando plena, rasa, geral e irrevogável quitação quanto a quaisquer direitos decorrentes, para nada mais reclamar, em juízo ou fora dele. "
                  />
                </div>
                <hr className="mt-32 mt-xs-0 mb-32" />
                <div className="row">
                  <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                    <div className="d-block d-md-flex align-items-center">
                      <Button
                        disabled={!isValid}
                        className="ms-0 ms-md-3"
                        onClick={handleSubmit}
                      >
                        Continuar
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};
